import CountryRegionData from 'country-region-data/data.json';
import PropTypes from 'prop-types';
import { Fragment, memo, useMemo } from 'react';

const options = CountryRegionData || [];

const normalizeValue = (value) => {
  switch (value) {
    case 'CUB':
      return 'CU';
    default:
      return value;
  }
};

const CountryPreview = ({ value, defaultValue }) => {
  const element = useMemo(() => {
    const toMatch = normalizeValue(value);
    return options.find((e) => e.countryShortCode === toMatch);
  }, [value]);
  return element?.countryName || (defaultValue || <Fragment/>);
};

export default memo(CountryPreview);

CountryPreview.propTypes = {
  defaultValue: PropTypes.any,
  value: PropTypes.any,
};

const getCountryElement = (value, defaultValue) => {
  const toMatch = normalizeValue(value);
  return options.find((e) => e.countryShortCode === toMatch)?.countryName || defaultValue || '';
};

export {
  getCountryElement
};
